module.exports = __webpack_public_path__ + "assets/images/cam-403482d58057a3f9f577d13530961a0e.svg";